import React from 'react';
import { Switch } from 'react-router-dom';
import ThemeProvider from '@/assets/styles/theme';

import '@/assets/styles/global.css';

function App(props) {
  return (
    <ThemeProvider>
      <Switch>{props.children}</Switch>
    </ThemeProvider>
  );
}

export default App;
